import React, { useState, useEffect } from 'react'
import { ContactAddIcon, ContactSubIcon } from '../../../../conf/images'
import EventEmitter from '../../../../utils/event'
import './index.css'
import {
    ObjectType,
    ContactObject,
    getContacts,
} from '../../../../service/api/bot'
import { useHistory } from 'react-router'
import { ContactsPage } from '../../../../conf/routePath'
import ContactItem from './ContactItem'
import RadioItem from '../../../../components/RadioItem'
import { IsetSate } from '../../../ScheduleRemindDetail'

interface ContactSelectorProps {
    title?: string
    className?: string
    contactType?: ObjectType
    values?: IsetSate
    changeValues: (value: any, item: any, index?: number) => void
    selectType: boolean
    selectList: Array<string>
}

interface OptionButtonProps {
    type: 'add' | 'sub'
    onSelect?: () => void
}
const OptionButton: React.FC<OptionButtonProps> = (props) => {
    const { type } = props
    return (
        <span className='contact-option option-item' onClick={props.onSelect}>
            {type === 'add' && (
                <img className='option-icon' src={ContactAddIcon} alt='icon' />
            )}
            {type === 'sub' && (
                <img className='option-icon' src={ContactSubIcon} alt='icon' />
            )}
        </span>
    )
}
const ContactSelector: React.FC<ContactSelectorProps> = (props) => {
    const initialValues = {
        title: '',
        content: [],
        share_alert: true,
        share_friend_all: false,
        shard_friends: [''],
        share_group_all: false,
        share_groups: [''],
        run_datetime: '',
    }
    const {
        contactType = 'GROUP',
        values = initialValues,
        changeValues,
        selectType = true,
        selectList,
    } = props
    const history = useHistory()
    const [allList, setAllList] = useState<ContactObject[]>([])
    React.useEffect(() => {
        getAllList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const getAllList = async () => {
        let contactsRes = await getContacts({ contacts_type: contactType })
        let contacts = contactsRes.wechaty_contacts_list
        setAllList(contacts)
    }
    useEffect(() => {
        if (allList) {
            EventEmitter.on('selectGroup', (data, type) => {
                data = data.map((item) => item.uid)
                if (type === 'GROUP') {
                    changeValues(data, 'share_groups')
                } else {
                    changeValues(data, 'shard_friends')
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allList])
    const realData = () => {
        let realData = allList.filter((con) => {
            return selectList.indexOf(con.uid) !== -1
        })
        return realData
    }

    return (
        <div className={`contact-selector ${props.className || ''}`}>
            {contactType === 'GROUP' && (
                <div className='detail-item'>
                    <span className='title'>群</span>
                    <RadioItem
                        className='contact-radio-item'
                        label='全部群'
                        selected={values.share_group_all}
                        onSelect={() => changeValues(true, 'share_group_all')}
                    />
                    <RadioItem
                        className='contact-radio-item'
                        label='指定群'
                        selected={!values.share_group_all}
                        onSelect={() => changeValues(false, 'share_group_all')}
                    />
                </div>
            )}
            {contactType === 'FRIEND' && (
                <div className='detail-item'>
                    <span className='title'>好友</span>
                    <RadioItem
                        className='contact-radio-item'
                        label='全部好友'
                        selected={values.share_friend_all}
                        onSelect={() => changeValues(true, 'share_friend_all')}
                    />
                    <RadioItem
                        className='contact-radio-item'
                        label='指定好友'
                        selected={!values.share_friend_all}
                        onSelect={() => changeValues(false, 'share_friend_all')}
                    />
                </div>
            )}
            <div className='contact-list'>
                {!selectType &&
                    realData().map((item) => (
                        <ContactItem
                            className='contact-object-item'
                            key={item.uid}
                            nickname={item.name}
                            avatar={item.head_url}
                        />
                    ))}
                {!selectType && (
                    <OptionButton
                        type='add'
                        onSelect={() => {
                            history.push(ContactsPage, {
                                type: contactType,
                                option: 'add',
                                pages: 'schedule',
                                selectedList: realData(),
                            })
                        }}
                    />
                )}
                {realData().length > 0 && !selectType && (
                    <OptionButton
                        type='sub'
                        onSelect={() => {
                            history.push(ContactsPage, {
                                type: contactType,
                                option: 'sub',
                                pages: 'schedule',
                                selectedList: realData(),
                            })
                        }}
                    />
                )}
            </div>
        </div>
    )
}

export default ContactSelector
